module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 23);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/regenerator");

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return iframeDOMElementID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return modalDOMElementID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return storeKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UX_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return OPENLOGIN_METHOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALLOWED_INTERACTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return OPENLOGIN_NETWORK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOGIN_PROVIDER; });
var iframeDOMElementID = "openlogin-iframe";
var modalDOMElementID = "openlogin-modal";
var storeKey = "openlogin_store";
var UX_MODE = {
  POPUP: "popup",
  REDIRECT: "redirect"
};
var OPENLOGIN_METHOD = {
  LOGIN: "openlogin_login",
  LOGOUT: "openlogin_logout",
  CHECK_3PC_SUPPORT: "openlogin_check_3PC_support",
  SET_PID_DATA: "openlogin_set_pid_data",
  GET_DATA: "openlogin_get_data"
}; // autocomplete workaround https://github.com/microsoft/TypeScript/issues/29729

var ALLOWED_INTERACTIONS = {
  POPUP: "popup",
  REDIRECT: "redirect",
  JRPC: "jrpc"
};
var OPENLOGIN_NETWORK = {
  MAINNET: "mainnet",
  TESTNET: "testnet",
  DEVELOPMENT: "development"
};
var LOGIN_PROVIDER = {
  GOOGLE: "google",
  FACEBOOK: "facebook",
  REDDIT: "reddit",
  DISCORD: "discord",
  TWITCH: "twitch",
  APPLE: "apple",
  LINE: "line",
  GITHUB: "github",
  KAKAO: "kakao",
  LINKEDIN: "linkedin",
  TWITTER: "twitter",
  WEIBO: "weibo",
  WECHAT: "wechat",
  EMAIL_PASSWORDLESS: "email_passwordless",
  WEBAUTHN: "webauthn"
};

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/asyncToGenerator");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return documentReady; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return htmlToElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return whitelistUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getHashQueryParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return awaitReq; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return constructURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return storageAvailable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return sessionStorageAvailable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return localStorageAvailable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return preloadIframe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getPopupFeatures; });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _toruslabs_eccrypto__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9);
/* harmony import */ var _toruslabs_eccrypto__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_toruslabs_eccrypto__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _toruslabs_openlogin_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var _toruslabs_openlogin_utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_toruslabs_openlogin_utils__WEBPACK_IMPORTED_MODULE_3__);




function documentReady() {
  return _documentReady.apply(this, arguments);
}

function _documentReady() {
  _documentReady = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.mark(function _callee() {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve) {
              if (document.readyState !== "loading") {
                resolve();
              } else {
                document.addEventListener("DOMContentLoaded", function () {
                  resolve();
                });
              }
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _documentReady.apply(this, arguments);
}

var htmlToElement = function htmlToElement(html) {
  var template = window.document.createElement("template");
  var trimmedHtml = html.trim(); // Never return a text node of whitespace as the result

  template.innerHTML = trimmedHtml;
  return template.content.firstChild;
};
function whitelistUrl(_x, _x2, _x3) {
  return _whitelistUrl.apply(this, arguments);
}

function _whitelistUrl() {
  _whitelistUrl = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.mark(function _callee2(clientId, appKey, origin) {
    var appKeyBuf, sig;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            appKeyBuf = Buffer.from(appKey.padStart(64, "0"), "hex");

            if (!(_toruslabs_openlogin_utils__WEBPACK_IMPORTED_MODULE_3__["base64url"].encode(Object(_toruslabs_eccrypto__WEBPACK_IMPORTED_MODULE_2__["getPublic"])(appKeyBuf)) !== clientId)) {
              _context2.next = 3;
              break;
            }

            throw new Error("appKey mismatch");

          case 3:
            _context2.next = 5;
            return Object(_toruslabs_eccrypto__WEBPACK_IMPORTED_MODULE_2__["sign"])(appKeyBuf, Buffer.from(Object(_toruslabs_openlogin_utils__WEBPACK_IMPORTED_MODULE_3__["keccak"])("keccak256").update(origin).digest("hex"), "hex"));

          case 5:
            sig = _context2.sent;
            return _context2.abrupt("return", _toruslabs_openlogin_utils__WEBPACK_IMPORTED_MODULE_3__["base64url"].encode(sig));

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _whitelistUrl.apply(this, arguments);
}

function getHashQueryParams() {
  var replaceUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var result = {};
  var url = new URL(window.location.href);
  url.searchParams.forEach(function (value, key) {
    if (key !== "result") {
      result[key] = value;
    }
  });
  var queryResult = url.searchParams.get("result");

  if (queryResult) {
    try {
      var queryParams = JSON.parse(Object(_toruslabs_openlogin_utils__WEBPACK_IMPORTED_MODULE_3__["safeatob"])(queryResult));
      Object.keys(queryParams).forEach(function (key) {
        result[key] = queryParams[key];
      });
    } catch (error) {
      window.console.error(error);
    }
  }

  var hash = url.hash.substr(1);
  var hashUrl = new URL("".concat(window.location.origin, "/?").concat(hash));
  hashUrl.searchParams.forEach(function (value, key) {
    if (key !== "result") {
      result[key] = value;
    }
  });
  var hashResult = hashUrl.searchParams.get("result");

  if (hashResult) {
    try {
      var hashParams = JSON.parse(Object(_toruslabs_openlogin_utils__WEBPACK_IMPORTED_MODULE_3__["safeatob"])(hashResult));
      Object.keys(hashParams).forEach(function (key) {
        result[key] = hashParams[key];
      });
    } catch (error) {
      window.console.error(error);
    }
  }

  if (replaceUrl) {
    var cleanUrl = window.location.origin + window.location.pathname;
    window.history.replaceState(null, "", cleanUrl);
  }

  return result;
}
function awaitReq(_x4, _x5) {
  return _awaitReq.apply(this, arguments);
}

function _awaitReq() {
  _awaitReq = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.mark(function _callee3(id, windowRef) {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", new Promise(function (resolve, reject) {
              var closedByHandler = false;
              var closedMonitor = setInterval(function () {
                if (!closedByHandler && windowRef.closed) {
                  reject(new Error("user closed popup"));
                }
              }, 500);

              var handler = function handler(ev) {
                var pid = ev.data.pid;
                if (id !== pid) return;
                window.removeEventListener("message", handler);
                closedByHandler = true;
                clearInterval(closedMonitor);
                windowRef.close();

                if (ev.data.data && ev.data.data.error) {
                  reject(new Error(ev.data.data.error));
                } else {
                  resolve(ev.data.data);
                }
              };

              window.addEventListener("message", handler);
            }));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _awaitReq.apply(this, arguments);
}

function constructURL(params) {
  var baseURL = params.baseURL,
      query = params.query,
      hash = params.hash;
  var url = new URL(baseURL);

  if (query) {
    Object.keys(query).forEach(function (key) {
      url.searchParams.append(key, query[key]);
    });
  }

  if (hash) {
    var h = new URL(constructURL({
      baseURL: baseURL,
      query: hash
    })).searchParams.toString();
    url.hash = h;
  }

  return url.toString();
}
function storageAvailable(type) {
  var storageExists = false;
  var storageLength = 0;
  var storage;

  try {
    storage = window[type];
    storageExists = true;
    storageLength = storage.length;
    var x = "__storage_test__";
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (error) {
    return error && ( // everything except Firefox
    error.code === 22 || // Firefox
    error.code === 1014 || // test name field too, because code might not be present
    // everything except Firefox
    error.name === "QuotaExceededErro r" || // Firefox
    error.name === "NS_ERROR_DOM_QUOTA_REACHED") && // acknowledge QuotaExceededError only if there's something already stored
    storageExists && storageLength !== 0;
  }
}
var sessionStorageAvailable = storageAvailable("sessionStorage");
var localStorageAvailable = storageAvailable("localStorage");
function preloadIframe(url) {
  try {
    var openloginIframeHtml = document.createElement("link");
    openloginIframeHtml.href = url;
    openloginIframeHtml.crossOrigin = "anonymous";
    openloginIframeHtml.type = "text/html";
    openloginIframeHtml.rel = "prefetch";

    if (openloginIframeHtml.relList && openloginIframeHtml.relList.supports) {
      if (openloginIframeHtml.relList.supports("prefetch")) {
        document.head.appendChild(openloginIframeHtml);
      }
    }
  } catch (error) {
    window.console.error(error);
  }
}
function getPopupFeatures() {
  // Fixes dual-screen position                             Most browsers      Firefox
  var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  var dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
  var w = 1200;
  var h = 700;
  var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.screen.width;
  var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : window.screen.height;
  var systemZoom = 1; // No reliable estimate

  var left = Math.abs((width - w) / 2 / systemZoom + dualScreenLeft);
  var top = Math.abs((height - h) / 2 / systemZoom + dualScreenTop);
  var features = "titlebar=0,toolbar=0,status=0,location=0,menubar=0,height=".concat(h / systemZoom, ",width=").concat(w / systemZoom, ",top=").concat(top, ",left=").concat(left);
  return features;
}

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = require("@toruslabs/openlogin-utils");

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = require("@toruslabs/openlogin-jrpc");

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/classCallCheck");

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/createClass");

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = require("@toruslabs/eccrypto");

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/slicedToArray");

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "@babel/runtime/helpers/typeof"
var typeof_ = __webpack_require__(15);
var typeof_default = /*#__PURE__*/__webpack_require__.n(typeof_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/slicedToArray"
var slicedToArray_ = __webpack_require__(11);
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/asyncToGenerator"
var asyncToGenerator_ = __webpack_require__(2);
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/classCallCheck"
var classCallCheck_ = __webpack_require__(7);
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/createClass"
var createClass_ = __webpack_require__(8);
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(3);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);

// EXTERNAL MODULE: external "@babel/runtime/regenerator"
var regenerator_ = __webpack_require__(0);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator_);

// EXTERNAL MODULE: external "@toruslabs/eccrypto"
var eccrypto_ = __webpack_require__(9);

// EXTERNAL MODULE: external "@toruslabs/http-helpers"
var http_helpers_ = __webpack_require__(16);

// EXTERNAL MODULE: external "@toruslabs/openlogin-jrpc"
var openlogin_jrpc_ = __webpack_require__(6);

// EXTERNAL MODULE: external "@toruslabs/openlogin-utils"
var openlogin_utils_ = __webpack_require__(5);

// EXTERNAL MODULE: external "lodash.merge"
var external_lodash_merge_ = __webpack_require__(19);
var external_lodash_merge_default = /*#__PURE__*/__webpack_require__.n(external_lodash_merge_);

// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(1);

// EXTERNAL MODULE: ./src/utils.ts
var utils = __webpack_require__(4);

// CONCATENATED MODULE: ./src/Modal.ts









var handleStream = function handleStream(handle, eventName, handler) {
  var handlerWrapper = function handlerWrapper(chunk) {
    handler(chunk);
    handle.removeListener(eventName, handlerWrapper);
  };

  handle.on(eventName, handlerWrapper);
};
var Modal_Modal = /*#__PURE__*/function () {
  function Modal(modalUrl) {
    classCallCheck_default()(this, Modal);

    defineProperty_default()(this, "modalUrl", void 0);

    defineProperty_default()(this, "iframeElem", void 0);

    defineProperty_default()(this, "initialized", false);

    defineProperty_default()(this, "modalZIndex", 99999);

    defineProperty_default()(this, "mux", void 0);

    defineProperty_default()(this, "verifierStream", void 0);

    this.modalUrl = modalUrl;
  }

  createClass_default()(Modal, [{
    key: "init",
    value: function () {
      var _init = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.initIFrame(this.modalUrl);

              case 2:
                this.setupStream();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "setupStream",
    value: function setupStream() {
      if (this.iframeElem === null) throw new Error("iframe is null");
      this.mux = Object(openlogin_jrpc_["setupMultiplex"])(new openlogin_jrpc_["PostMessageStream"]({
        name: "modal_iframe_rpc",
        target: "modal_rpc",
        targetWindow: this.iframeElem.contentWindow
      }));
      this.verifierStream = this.mux.createStream("verifier");
    }
  }, {
    key: "initIFrame",
    value: function () {
      var _initIFrame = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(src) {
        var documentIFrameElem, iframeElem;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(utils["c" /* documentReady */])();

              case 2:
                documentIFrameElem = document.getElementById(constants["g" /* modalDOMElementID */]);

                if (documentIFrameElem) {
                  documentIFrameElem.remove();
                  window.console.log("already initialized, removing previous modal iframe");
                }

                iframeElem = document.createElement("iframe");
                iframeElem.src = src;
                iframeElem.id = constants["g" /* modalDOMElementID */];
                this.iframeElem = iframeElem;

                this._hideModal();

                document.body.appendChild(this.iframeElem);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function initIFrame(_x) {
        return _initIFrame.apply(this, arguments);
      }

      return initIFrame;
    }()
  }, {
    key: "_showModal",
    value: function _showModal() {
      var style = {};
      style.display = "block";
      style.position = "fixed";
      style.width = "100%";
      style.height = "100%";
      style.top = "0px";
      style.right = "0px";
      style.left = "0px";
      style.bottom = "0px";
      style.border = "0";
      style["z-index"] = this.modalZIndex;
      this.iframeElem.setAttribute("style", Object.entries(style).map(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            k = _ref2[0],
            v = _ref2[1];

        return "".concat(k, ":").concat(v);
      }).join(";"));
    }
  }, {
    key: "_hideModal",
    value: function _hideModal() {
      var style = {};
      style.display = "none";
      style.position = "fixed";
      style.width = "100%";
      style.height = "100%";
      style.top = "0px";
      style.right = "0px";
      style.left = "0px";
      style.bottom = "0px";
      style.border = "0";
      style["z-index"] = this.modalZIndex;
      this.iframeElem.setAttribute("style", Object.entries(style).map(function (_ref3) {
        var _ref4 = slicedToArray_default()(_ref3, 2),
            k = _ref4[0],
            v = _ref4[1];

        return "".concat(k, ":").concat(v);
      }).join(";"));
    }
  }, {
    key: "_prompt",
    value: function () {
      var _prompt2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(clientId, whiteLabel, cb) {
        var _this = this;

        var modalHandler;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this._showModal();

                modalHandler = function modalHandler(chunk) {
                  _this._hideModal();

                  cb(chunk);
                };

                handleStream(this.verifierStream, "data", modalHandler);
                this.verifierStream.write({
                  name: "prompt",
                  clientId: clientId,
                  whiteLabel: whiteLabel
                });

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _prompt(_x2, _x3, _x4) {
        return _prompt2.apply(this, arguments);
      }

      return _prompt;
    }()
  }, {
    key: "cleanup",
    value: function () {
      var _cleanup = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var documentIFrameElem;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return Object(utils["c" /* documentReady */])();

              case 2:
                documentIFrameElem = document.getElementById(constants["g" /* modalDOMElementID */]);

                if (documentIFrameElem) {
                  documentIFrameElem.remove();
                  this.iframeElem = null;
                }

                this.initialized = false;

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function cleanup() {
        return _cleanup.apply(this, arguments);
      }

      return cleanup;
    }()
  }]);

  return Modal;
}();
// EXTERNAL MODULE: ./src/OpenLoginStore.ts + 1 modules
var OpenLoginStore = __webpack_require__(14);

// EXTERNAL MODULE: ./src/Provider.ts
var Provider = __webpack_require__(13);

// CONCATENATED MODULE: ./src/OpenLogin.ts








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











Object(utils["h" /* preloadIframe */])("https://app.openlogin.com/start");
Object(utils["h" /* preloadIframe */])("https://app.openlogin.com/sdk-modal");

var OpenLogin_OpenLogin = /*#__PURE__*/function () {
  function OpenLogin(options) {
    var _options$no3PC, _options$_startUrl, _options$_popupUrl, _options$redirectUrl, _options$uxMode, _options$replaceUrlOn, _options$originData, _options$whiteLabel, _options$loginConfig;

    classCallCheck_default()(this, OpenLogin);

    defineProperty_default()(this, "provider", void 0);

    defineProperty_default()(this, "state", void 0);

    defineProperty_default()(this, "modal", void 0);

    this.provider = new Proxy(new Provider["a" /* default */](), {
      deleteProperty: function deleteProperty() {
        return true;
      } // work around for web3

    });

    if (options.network === constants["d" /* OPENLOGIN_NETWORK */].MAINNET) {
      options._iframeUrl = "https://app.openlogin.com";
    } else if (options.network === constants["d" /* OPENLOGIN_NETWORK */].TESTNET) {
      options._iframeUrl = "https://beta.openlogin.com";
    } else if (!options._iframeUrl) {
      throw new Error("unspecified network and iframeUrl");
    }

    this.modal = new Modal_Modal("".concat(options._iframeUrl, "/sdk-modal"));
    this.initState(_objectSpread(_objectSpread({}, options), {}, {
      no3PC: (_options$no3PC = options.no3PC) !== null && _options$no3PC !== void 0 ? _options$no3PC : false,
      _iframeUrl: options._iframeUrl,
      _startUrl: (_options$_startUrl = options._startUrl) !== null && _options$_startUrl !== void 0 ? _options$_startUrl : "".concat(options._iframeUrl, "/start"),
      _popupUrl: (_options$_popupUrl = options._popupUrl) !== null && _options$_popupUrl !== void 0 ? _options$_popupUrl : "".concat(options._iframeUrl, "/popup-window"),
      redirectUrl: (_options$redirectUrl = options.redirectUrl) !== null && _options$redirectUrl !== void 0 ? _options$redirectUrl : "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname),
      uxMode: (_options$uxMode = options.uxMode) !== null && _options$uxMode !== void 0 ? _options$uxMode : constants["e" /* UX_MODE */].REDIRECT,
      replaceUrlOnRedirect: (_options$replaceUrlOn = options.replaceUrlOnRedirect) !== null && _options$replaceUrlOn !== void 0 ? _options$replaceUrlOn : true,
      originData: (_options$originData = options.originData) !== null && _options$originData !== void 0 ? _options$originData : defineProperty_default()({}, window.location.origin, ""),
      whiteLabel: (_options$whiteLabel = options.whiteLabel) !== null && _options$whiteLabel !== void 0 ? _options$whiteLabel : {},
      loginConfig: (_options$loginConfig = options.loginConfig) !== null && _options$loginConfig !== void 0 ? _options$loginConfig : {}
    }));
  }

  createClass_default()(OpenLogin, [{
    key: "initState",
    value: function initState(options) {
      this.state = {
        uxMode: options.uxMode,
        network: options.network,
        store: OpenLoginStore["a" /* default */].getInstance(),
        iframeUrl: options._iframeUrl,
        startUrl: options._startUrl,
        popupUrl: options._popupUrl,
        clientId: options.clientId,
        redirectUrl: options.redirectUrl,
        replaceUrlOnRedirect: options.replaceUrlOnRedirect,
        originData: options.originData,
        loginConfig: options.loginConfig,
        support3PC: !options.no3PC,
        whiteLabel: options.whiteLabel
      };
    }
  }, {
    key: "init",
    value: function () {
      var _init = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var res;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.state.support3PC) {
                  _context.next = 16;
                  break;
                }

                _context.next = 3;
                return Promise.all([this.provider.init({
                  iframeUrl: this.state.iframeUrl
                }), this.modal.init(), this.updateOriginData()]);

              case 3:
                this._syncState(Object(utils["d" /* getHashQueryParams */])(this.state.replaceUrlOnRedirect));

                _context.next = 6;
                return this._check3PCSupport();

              case 6:
                res = _context.sent;
                this.state.support3PC = !!res.support3PC;

                if (!this.state.support3PC) {
                  _context.next = 14;
                  break;
                }

                _context.t0 = this;
                _context.next = 12;
                return this._getData();

              case 12:
                _context.t1 = _context.sent;

                _context.t0._syncState.call(_context.t0, _context.t1);

              case 14:
                _context.next = 19;
                break;

              case 16:
                _context.next = 18;
                return this.updateOriginData();

              case 18:
                this._syncState(Object(utils["d" /* getHashQueryParams */])(this.state.replaceUrlOnRedirect));

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "privKey",
    get: function get() {
      return this.state.privKey ? this.state.privKey.padStart(64, "0") : "";
    }
  }, {
    key: "updateOriginData",
    value: function () {
      var _updateOriginData = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var filteredOriginData, _yield$Promise$all, _yield$Promise$all2, whitelist, whiteLabel;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                filteredOriginData = JSON.parse(JSON.stringify(this.state.originData));
                Object.keys(filteredOriginData).forEach(function (key) {
                  if (filteredOriginData[key] === "") delete filteredOriginData[key];
                });
                _context2.next = 4;
                return Promise.all([this.getWhitelist(), this.getWhiteLabel()]);

              case 4:
                _yield$Promise$all = _context2.sent;
                _yield$Promise$all2 = slicedToArray_default()(_yield$Promise$all, 2);
                whitelist = _yield$Promise$all2[0];
                whiteLabel = _yield$Promise$all2[1];

                this._syncState({
                  originData: _objectSpread(_objectSpread({}, whitelist), filteredOriginData),
                  whiteLabel: _objectSpread(_objectSpread({}, whiteLabel), this.state.whiteLabel)
                });

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function updateOriginData() {
        return _updateOriginData.apply(this, arguments);
      }

      return updateOriginData;
    }()
  }, {
    key: "getWhitelist",
    value: function () {
      var _getWhitelist = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var clientId, res;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                clientId = this.state.clientId;

                if (clientId) {
                  _context3.next = 4;
                  break;
                }

                throw new Error("unspecified clientId");

              case 4:
                _context3.next = 6;
                return Object(http_helpers_["post"])("https://api.developer.tor.us/whitelist", {
                  project_id: this.state.clientId
                });

              case 6:
                res = _context3.sent;
                return _context3.abrupt("return", res.signed_urls);

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", {});

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 10]]);
      }));

      function getWhitelist() {
        return _getWhitelist.apply(this, arguments);
      }

      return getWhitelist;
    }()
  }, {
    key: "getWhiteLabel",
    value: function () {
      var _getWhiteLabel = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var clientId, res;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                clientId = this.state.clientId;

                if (clientId) {
                  _context4.next = 4;
                  break;
                }

                throw new Error("unspecified clientId");

              case 4:
                _context4.next = 6;
                return Object(http_helpers_["post"])("https://api.developer.tor.us/whitelabel", {
                  project_id: this.state.clientId
                });

              case 6:
                res = _context4.sent;
                return _context4.abrupt("return", res.whiteLabel);

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](0);
                return _context4.abrupt("return", {});

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 10]]);
      }));

      function getWhiteLabel() {
        return _getWhiteLabel.apply(this, arguments);
      }

      return getWhiteLabel;
    }()
  }, {
    key: "_fastLogin",
    value: function () {
      var _fastLogin2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(params) {
        var defaultParams, loginParams, res;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                defaultParams = {
                  redirectUrl: this.state.redirectUrl
                };
                loginParams = _objectSpread(_objectSpread({}, defaultParams), params);
                _context5.next = 4;
                return this.request({
                  params: [_objectSpread(_objectSpread({}, loginParams), {}, {
                    fastLogin: true
                  })],
                  method: constants["c" /* OPENLOGIN_METHOD */].LOGIN,
                  startUrl: this.state.startUrl,
                  popupUrl: this.state.popupUrl,
                  allowedInteractions: [constants["a" /* ALLOWED_INTERACTIONS */].POPUP, constants["a" /* ALLOWED_INTERACTIONS */].REDIRECT]
                });

              case 4:
                res = _context5.sent;
                this.state.privKey = res.privKey;
                return _context5.abrupt("return", res);

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _fastLogin(_x) {
        return _fastLogin2.apply(this, arguments);
      }

      return _fastLogin;
    }()
  }, {
    key: "login",
    value: function () {
      var _login = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6(params) {
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(params && params.loginProvider)) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt("return", this._selectedLogin(params));

              case 2:
                return _context6.abrupt("return", this._modal(params));

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function login(_x2) {
        return _login.apply(this, arguments);
      }

      return login;
    }()
  }, {
    key: "_selectedLogin",
    value: function () {
      var _selectedLogin2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7(params) {
        var defaultParams, loginParams, res;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                defaultParams = {
                  redirectUrl: this.state.redirectUrl
                };
                loginParams = _objectSpread(_objectSpread({
                  loginProvider: params.loginProvider
                }, defaultParams), params); // fast login flow
                // if (this.state.store.get("touchIDPreference") === "enabled" && !loginParams.extraLoginOptions?.login_hint) {
                //   return this._fastLogin(loginParams);
                // }

                _context7.next = 4;
                return this.request({
                  method: constants["c" /* OPENLOGIN_METHOD */].LOGIN,
                  allowedInteractions: [constants["e" /* UX_MODE */].REDIRECT, constants["e" /* UX_MODE */].POPUP],
                  startUrl: this.state.startUrl,
                  popupUrl: this.state.popupUrl,
                  params: [loginParams]
                });

              case 4:
                res = _context7.sent;
                this.state.privKey = res.privKey;
                return _context7.abrupt("return", res);

              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function _selectedLogin(_x3) {
        return _selectedLogin2.apply(this, arguments);
      }

      return _selectedLogin;
    }()
  }, {
    key: "logout",
    value: function () {
      var _logout = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
        var logoutParams,
            params,
            res,
            _args8 = arguments;
        return regenerator_default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                logoutParams = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};
                params = {}; // defaults

                params.redirectUrl = this.state.redirectUrl;
                params._clientId = this.state.clientId;

                if (logoutParams.clientId) {
                  params._clientId = logoutParams.clientId;
                }

                if (logoutParams.fastLogin !== undefined) {
                  params.fastLogin = logoutParams.fastLogin;
                }

                if (logoutParams.redirectUrl !== undefined) {
                  params.redirectUrl = logoutParams.redirectUrl;
                }

                _context8.next = 9;
                return this.request({
                  method: constants["c" /* OPENLOGIN_METHOD */].LOGOUT,
                  params: [params],
                  startUrl: this.state.startUrl,
                  popupUrl: this.state.popupUrl,
                  allowedInteractions: [constants["a" /* ALLOWED_INTERACTIONS */].JRPC, constants["a" /* ALLOWED_INTERACTIONS */].POPUP, constants["a" /* ALLOWED_INTERACTIONS */].REDIRECT]
                });

              case 9:
                res = _context8.sent;
                this.state.privKey = ""; // if (!params.fastLogin) this.state.store.set("touchIDPreference", "disabled");

                return _context8.abrupt("return", res);

              case 12:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function logout() {
        return _logout.apply(this, arguments);
      }

      return logout;
    }()
  }, {
    key: "request",
    value: function () {
      var _request = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9(args) {
        var _ref2;

        var pid, params, session, startUrl, popupUrl, method, allowedInteractions, userData, sig, u, windowRef, _u, _windowRef;

        return regenerator_default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                pid = Object(openlogin_utils_["randomId"])();
                params = args.params; // Note: _origin is added later in postMessageStream for jrpc requests
                // do not add it here since its used for checking postMessage constraints

                session = {};

                if (!(params.length !== 1)) {
                  _context9.next = 5;
                  break;
                }

                throw new Error("request params array should have only one element");

              case 5:
                startUrl = args.startUrl, popupUrl = args.popupUrl, method = args.method, allowedInteractions = args.allowedInteractions;

                if (!(allowedInteractions.length === 0)) {
                  _context9.next = 8;
                  break;
                }

                throw new Error("no allowed interactions");

              case 8:
                if (this.state.clientId) {
                  session._clientId = this.state.clientId;
                }

                if (!this.state.privKey) {
                  _context9.next = 17;
                  break;
                }

                userData = {
                  clientId: session._clientId,
                  timestamp: Date.now().toString()
                };
                _context9.next = 13;
                return Object(eccrypto_["sign"])(Buffer.from(this.state.privKey.padStart(64, "0"), "hex"), Buffer.from(Object(openlogin_utils_["keccak"])("keccak256").update(JSON.stringify(userData)).digest("hex"), "hex"));

              case 13:
                sig = _context9.sent;
                session._user = Object(eccrypto_["getPublic"])(Buffer.from(this.state.privKey.padStart(64, "0"), "hex")).toString("hex");
                session._userSig = openlogin_utils_["base64url"].encode(sig);
                session._userData = userData;

              case 17:
                session._originData = this.state.originData;
                session._whiteLabelData = this.state.whiteLabel;
                session._loginConfig = this.state.loginConfig; // add in session data (allow overrides)

                params = [_objectSpread(_objectSpread({}, session), params[0])]; // use JRPC where possible

                if (!(this.state.support3PC && allowedInteractions.includes(constants["a" /* ALLOWED_INTERACTIONS */].JRPC))) {
                  _context9.next = 23;
                  break;
                }

                return _context9.abrupt("return", this._jrpcRequest({
                  method: method,
                  params: params
                }));

              case 23:
                // set origin
                params[0]._origin = new URL((_ref2 = params[0].redirectUrl) !== null && _ref2 !== void 0 ? _ref2 : this.state.redirectUrl).origin; // preset params

                if (!this.state.support3PC) {
                  _context9.next = 28;
                  break;
                }

                _context9.next = 27;
                return this._setPIDData(pid, params);

              case 27:
                params = [{}];

              case 28:
                if (!(!startUrl || !popupUrl)) {
                  _context9.next = 30;
                  break;
                }

                throw new Error("no url for redirect / popup flow");

              case 30:
                if (!(this.state.uxMode === constants["e" /* UX_MODE */].REDIRECT)) {
                  _context9.next = 40;
                  break;
                }

                if (!allowedInteractions.includes(constants["a" /* ALLOWED_INTERACTIONS */].REDIRECT)) {
                  _context9.next = 34;
                  break;
                }

                // give time for synchronous methods to complete before redirect
                setTimeout(function () {
                  window.location.href = Object(utils["b" /* constructURL */])({
                    baseURL: startUrl,
                    hash: {
                      b64Params: Object(openlogin_utils_["jsonToBase64"])(params[0]),
                      _pid: pid,
                      _method: method
                    }
                  });
                }, 50);
                return _context9.abrupt("return", {});

              case 34:
                if (!allowedInteractions.includes(constants["a" /* ALLOWED_INTERACTIONS */].POPUP)) {
                  _context9.next = 38;
                  break;
                }

                u = new URL(Object(utils["b" /* constructURL */])({
                  baseURL: popupUrl,
                  hash: {
                    b64Params: Object(openlogin_utils_["jsonToBase64"])(params[0]),
                    _pid: pid,
                    _method: method
                  }
                }));
                windowRef = window.open(u.toString(), "_blank", Object(utils["e" /* getPopupFeatures */])());
                return _context9.abrupt("return", Object(utils["a" /* awaitReq */])(pid, windowRef));

              case 38:
                _context9.next = 47;
                break;

              case 40:
                if (!allowedInteractions.includes(constants["a" /* ALLOWED_INTERACTIONS */].POPUP)) {
                  _context9.next = 44;
                  break;
                }

                _u = new URL(Object(utils["b" /* constructURL */])({
                  baseURL: popupUrl,
                  hash: {
                    b64Params: Object(openlogin_utils_["jsonToBase64"])(params[0]),
                    _pid: pid,
                    _method: method
                  }
                }));
                _windowRef = window.open(_u.toString(), "_blank", Object(utils["e" /* getPopupFeatures */])());
                return _context9.abrupt("return", Object(utils["a" /* awaitReq */])(pid, _windowRef));

              case 44:
                if (!allowedInteractions.includes(constants["a" /* ALLOWED_INTERACTIONS */].REDIRECT)) {
                  _context9.next = 47;
                  break;
                }

                // give time for synchronous methods to complete before redirect
                setTimeout(function () {
                  window.location.href = Object(utils["b" /* constructURL */])({
                    baseURL: startUrl,
                    hash: {
                      b64Params: Object(openlogin_utils_["jsonToBase64"])(params[0]),
                      _pid: pid,
                      _method: method
                    }
                  });
                }, 50);
                return _context9.abrupt("return", null);

              case 47:
                throw new Error("no matching allowed interactions");

              case 48:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function request(_x4) {
        return _request.apply(this, arguments);
      }

      return request;
    }()
  }, {
    key: "_jrpcRequest",
    value: function () {
      var _jrpcRequest2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10(args) {
        var _this = this;

        var method, params;
        return regenerator_default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!(!args || typeof_default()(args) !== "object" || Array.isArray(args))) {
                  _context10.next = 2;
                  break;
                }

                throw new Error("invalid request args");

              case 2:
                method = args.method, params = args.params;

                if (!(typeof method !== "string" || method.length === 0)) {
                  _context10.next = 5;
                  break;
                }

                throw new Error("invalid request method");

              case 5:
                if (!(params === undefined || !Array.isArray(params))) {
                  _context10.next = 7;
                  break;
                }

                throw new Error("invalid request params");

              case 7:
                if (params.length === 0) {
                  params.push({});
                }

                return _context10.abrupt("return", new Promise(function (resolve, reject) {
                  _this.provider._rpcRequest({
                    method: method,
                    params: params
                  }, Object(openlogin_jrpc_["getRpcPromiseCallback"])(resolve, reject));
                }));

              case 9:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function _jrpcRequest(_x5) {
        return _jrpcRequest2.apply(this, arguments);
      }

      return _jrpcRequest;
    }()
  }, {
    key: "_check3PCSupport",
    value: function () {
      var _check3PCSupport2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee11() {
        return regenerator_default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt("return", this._jrpcRequest({
                  method: constants["c" /* OPENLOGIN_METHOD */].CHECK_3PC_SUPPORT,
                  params: [{
                    _originData: this.state.originData
                  }]
                }));

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function _check3PCSupport() {
        return _check3PCSupport2.apply(this, arguments);
      }

      return _check3PCSupport;
    }()
  }, {
    key: "_setPIDData",
    value: function () {
      var _setPIDData2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee12(pid, data) {
        return regenerator_default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.request({
                  allowedInteractions: [constants["a" /* ALLOWED_INTERACTIONS */].JRPC],
                  method: constants["c" /* OPENLOGIN_METHOD */].SET_PID_DATA,
                  params: [{
                    pid: pid,
                    data: data[0]
                  }]
                });

              case 2:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function _setPIDData(_x6, _x7) {
        return _setPIDData2.apply(this, arguments);
      }

      return _setPIDData;
    }()
  }, {
    key: "_getData",
    value: function () {
      var _getData2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee13() {
        return regenerator_default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                return _context13.abrupt("return", this.request({
                  allowedInteractions: [constants["a" /* ALLOWED_INTERACTIONS */].JRPC],
                  method: constants["c" /* OPENLOGIN_METHOD */].GET_DATA,
                  params: [{}]
                }));

              case 1:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function _getData() {
        return _getData2.apply(this, arguments);
      }

      return _getData;
    }()
  }, {
    key: "_syncState",
    value: function _syncState(newState) {
      var _this2 = this;

      if (newState.store) {
        if (typeof_default()(newState.store) !== "object") {
          throw new Error("expected store to be an object");
        }

        Object.keys(newState.store).forEach(function (key) {
          _this2.state.store.set(key, newState.store[key]);
        });
      }

      var store = this.state.store;
      this.state = _objectSpread(_objectSpread(_objectSpread({}, this.state), newState), {}, {
        store: store
      });
    }
  }, {
    key: "_modal",
    value: function () {
      var _modal2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee15(params) {
        var _this3 = this;

        return regenerator_default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                return _context15.abrupt("return", new Promise(function (resolve, reject) {
                  _this3.modal._prompt(_this3.state.clientId, _this3.state.whiteLabel, /*#__PURE__*/function () {
                    var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee14(chunk) {
                      return regenerator_default.a.wrap(function _callee14$(_context14) {
                        while (1) {
                          switch (_context14.prev = _context14.next) {
                            case 0:
                              if (!chunk.cancel) {
                                _context14.next = 4;
                                break;
                              }

                              reject(new Error("user canceled login"));
                              _context14.next = 9;
                              break;

                            case 4:
                              _context14.t0 = resolve;
                              _context14.next = 7;
                              return _this3._selectedLogin(external_lodash_merge_default()(params, chunk));

                            case 7:
                              _context14.t1 = _context14.sent;
                              (0, _context14.t0)(_context14.t1);

                            case 9:
                            case "end":
                              return _context14.stop();
                          }
                        }
                      }, _callee14);
                    }));

                    return function (_x9) {
                      return _ref3.apply(this, arguments);
                    };
                  }());
                }));

              case 1:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }));

      function _modal(_x8) {
        return _modal2.apply(this, arguments);
      }

      return _modal;
    }()
  }, {
    key: "_cleanup",
    value: function () {
      var _cleanup2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee16() {
        return regenerator_default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return this.provider.cleanup();

              case 2:
                _context16.next = 4;
                return this.modal.cleanup();

              case 4:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function _cleanup() {
        return _cleanup2.apply(this, arguments);
      }

      return _cleanup;
    }()
  }, {
    key: "encrypt",
    value: function () {
      var _encrypt2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee17(message, privateKey) {
        var privKey;
        return regenerator_default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                privKey = privateKey;

                if (!privKey) {
                  privKey = this.privKey;
                } // validations


                if (/^[0-9a-fA-f]*$/.exec(privKey)) {
                  _context17.next = 4;
                  break;
                }

                throw new Error("invalid private key");

              case 4:
                return _context17.abrupt("return", Object(eccrypto_["encrypt"])(Object(eccrypto_["getPublic"])(Buffer.from(privKey, "hex")), message));

              case 5:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function encrypt(_x10, _x11) {
        return _encrypt2.apply(this, arguments);
      }

      return encrypt;
    }()
  }, {
    key: "decrypt",
    value: function () {
      var _decrypt2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee18(ciphertext, privateKey) {
        var privKey;
        return regenerator_default.a.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                privKey = privateKey;

                if (!privKey) {
                  privKey = this.privKey;
                } // validations


                if (/^[0-9a-fA-f]*$/.exec(privKey)) {
                  _context18.next = 4;
                  break;
                }

                throw new Error("invalid private key");

              case 4:
                return _context18.abrupt("return", Object(eccrypto_["decrypt"])(Buffer.from(privKey, "hex"), ciphertext));

              case 5:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function decrypt(_x12, _x13) {
        return _decrypt2.apply(this, arguments);
      }

      return decrypt;
    }()
  }, {
    key: "getUserInfo",
    value: function () {
      var _getUserInfo = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee19() {
        var storeData, userInfo;
        return regenerator_default.a.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                if (!this.state.privKey) {
                  _context19.next = 4;
                  break;
                }

                storeData = this.state.store.getStore();
                userInfo = {
                  email: storeData.email || "",
                  name: storeData.name || "",
                  profileImage: storeData.profileImage || "",
                  aggregateVerifier: storeData.aggregateVerifier || "",
                  verifier: storeData.verifier || "",
                  verifierId: storeData.verifierId || "",
                  typeOfLogin: storeData.typeOfLogin || ""
                };
                return _context19.abrupt("return", userInfo);

              case 4:
                throw new Error("user should be logged in to fetch userInfo");

              case 5:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function getUserInfo() {
        return _getUserInfo.apply(this, arguments);
      }

      return getUserInfo;
    }()
  }]);

  return OpenLogin;
}();

/* harmony default export */ var src_OpenLogin = __webpack_exports__["a"] = (OpenLogin_OpenLogin);

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Provider; });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(0);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _toruslabs_openlogin_jrpc__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6);
/* harmony import */ var _toruslabs_openlogin_jrpc__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_toruslabs_openlogin_jrpc__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _toruslabs_openlogin_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5);
/* harmony import */ var _toruslabs_openlogin_utils__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_toruslabs_openlogin_utils__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var pump__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(22);
/* harmony import */ var pump__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(pump__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(4);










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }







var Provider = /*#__PURE__*/function (_SafeEventEmitter) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(Provider, _SafeEventEmitter);

  var _super = _createSuper(Provider);

  function Provider() {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, Provider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default()(_this), "iframeElem", null);

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default()(_this), "rpcStream", void 0);

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default()(_this), "rpcEngine", void 0);

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default()(_this), "initialized", void 0);

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default()(_this), "mux", void 0);

    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(Provider, [{
    key: "init",
    value: function () {
      var _init = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.mark(function _callee(_ref) {
        var iframeUrl;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                iframeUrl = _ref.iframeUrl;
                _context.next = 3;
                return this.initIFrame(iframeUrl);

              case 3:
                _context.next = 5;
                return this.setupStream();

              case 5:
                this.initialized = true;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init(_x) {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "initIFrame",
    value: function () {
      var _initIFrame = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.mark(function _callee2(src) {
        var documentIFrameElem, iframeElem;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(_utils__WEBPACK_IMPORTED_MODULE_13__[/* documentReady */ "c"])();

              case 2:
                documentIFrameElem = document.getElementById(_constants__WEBPACK_IMPORTED_MODULE_12__[/* iframeDOMElementID */ "f"]);

                if (documentIFrameElem) {
                  documentIFrameElem.remove();
                  window.console.log("already initialized, removing previous provider iframe");
                }

                iframeElem = document.createElement("iframe");
                iframeElem.src = src;
                iframeElem.id = _constants__WEBPACK_IMPORTED_MODULE_12__[/* iframeDOMElementID */ "f"];
                iframeElem.setAttribute("style", "display:none; position:fixed; top: 0; left: 0; width: 100%");
                document.body.appendChild(iframeElem);
                this.iframeElem = iframeElem;

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function initIFrame(_x2) {
        return _initIFrame.apply(this, arguments);
      }

      return initIFrame;
    }()
  }, {
    key: "setupStream",
    value: function () {
      var _setupStream = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.mark(function _callee3() {
        var JRPCConnection, rpcEngine;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(this.iframeElem === null)) {
                  _context3.next = 2;
                  break;
                }

                throw new Error("iframe is null");

              case 2:
                this.rpcStream = new _toruslabs_openlogin_jrpc__WEBPACK_IMPORTED_MODULE_9__["PostMessageStream"]({
                  name: "embed_rpc",
                  target: "iframe_rpc",
                  targetWindow: this.iframeElem.contentWindow
                });
                this.mux = Object(_toruslabs_openlogin_jrpc__WEBPACK_IMPORTED_MODULE_9__["setupMultiplex"])(this.rpcStream);
                JRPCConnection = Object(_toruslabs_openlogin_jrpc__WEBPACK_IMPORTED_MODULE_9__["createStreamMiddleware"])();
                pump__WEBPACK_IMPORTED_MODULE_11___default()(JRPCConnection.stream, this.mux.createStream("jrpc"), JRPCConnection.stream, function (error) {
                  window.console.log("JRPC connection broken", error);
                });
                rpcEngine = new _toruslabs_openlogin_jrpc__WEBPACK_IMPORTED_MODULE_9__["JRPCEngine"]();
                rpcEngine.push(Object(_toruslabs_openlogin_jrpc__WEBPACK_IMPORTED_MODULE_9__["createIdRemapMiddleware"])());
                rpcEngine.push(JRPCConnection.middleware);
                this.rpcEngine = rpcEngine;

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function setupStream() {
        return _setupStream.apply(this, arguments);
      }

      return setupStream;
    }()
  }, {
    key: "cleanup",
    value: function () {
      var _cleanup = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.mark(function _callee4() {
        var documentIFrameElem;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return Object(_utils__WEBPACK_IMPORTED_MODULE_13__[/* documentReady */ "c"])();

              case 2:
                documentIFrameElem = document.getElementById(_constants__WEBPACK_IMPORTED_MODULE_12__[/* iframeDOMElementID */ "f"]);

                if (documentIFrameElem) {
                  documentIFrameElem.remove();
                  this.iframeElem = null;
                }

                this.initialized = false;

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function cleanup() {
        return _cleanup.apply(this, arguments);
      }

      return cleanup;
    }()
  }, {
    key: "_rpcRequest",
    value: function _rpcRequest(payload, callback) {
      if (!payload.jsonrpc) {
        payload.jsonrpc = "2.0";
      }

      if (!payload.id) {
        payload.id = Object(_toruslabs_openlogin_utils__WEBPACK_IMPORTED_MODULE_10__["randomId"])();
      }

      this.rpcEngine.handle(payload, callback);
    }
  }]);

  return Provider;
}(_toruslabs_openlogin_jrpc__WEBPACK_IMPORTED_MODULE_9__["SafeEventEmitter"]);



/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ OpenLoginStore_OpenLoginStore; });

// EXTERNAL MODULE: external "@babel/runtime/helpers/classCallCheck"
var classCallCheck_ = __webpack_require__(7);
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/createClass"
var createClass_ = __webpack_require__(8);
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(3);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);

// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(1);

// CONCATENATED MODULE: ./src/MemoryStore.ts



var MemoryStore_MemoryStore = /*#__PURE__*/function () {
  function MemoryStore() {
    classCallCheck_default()(this, MemoryStore);

    defineProperty_default()(this, "store", {});
  }

  createClass_default()(MemoryStore, [{
    key: "getItem",
    value: function getItem(key) {
      return this.store[key];
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      this.store[key] = value;
    }
  }]);

  return MemoryStore;
}();
// EXTERNAL MODULE: ./src/utils.ts
var utils = __webpack_require__(4);

// CONCATENATED MODULE: ./src/OpenLoginStore.ts







var OpenLoginStore_OpenLoginStore = /*#__PURE__*/function () {
  function OpenLoginStore(storage) {
    classCallCheck_default()(this, OpenLoginStore);

    defineProperty_default()(this, "storage", void 0);

    this.storage = storage;

    if (!storage.getItem(constants["h" /* storeKey */])) {
      this.resetStore();
    }
  }

  createClass_default()(OpenLoginStore, [{
    key: "toJSON",
    value: function toJSON() {
      return this.storage.getItem(constants["h" /* storeKey */]);
    }
  }, {
    key: "resetStore",
    value: function resetStore() {
      var currStore = this.getStore();
      this.storage.setItem(constants["h" /* storeKey */], JSON.stringify({}));
      return currStore;
    }
  }, {
    key: "getStore",
    value: function getStore() {
      return JSON.parse(this.storage.getItem(constants["h" /* storeKey */]));
    }
  }, {
    key: "get",
    value: function get(key) {
      var store = JSON.parse(this.storage.getItem(constants["h" /* storeKey */]));
      return store[key];
    }
  }, {
    key: "set",
    value: function set(key, value) {
      var store = JSON.parse(this.storage.getItem(constants["h" /* storeKey */]));
      store[key] = value;
      this.storage.setItem(constants["h" /* storeKey */], JSON.stringify(store));
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (!this.instance) {
        this.instance = new this(utils["g" /* localStorageAvailable */] ? localStorage : new MemoryStore_MemoryStore());
      }

      return this.instance;
    }
  }]);

  return OpenLoginStore;
}();

defineProperty_default()(OpenLoginStore_OpenLoginStore, "instance", void 0);



/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/typeof");

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = require("@toruslabs/http-helpers");

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/getPrototypeOf");

/***/ }),
/* 18 */
/***/ (function(module, exports) {



/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = require("lodash.merge");

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inherits");

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/possibleConstructorReturn");

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = require("pump");

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _src_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "iframeDOMElementID", function() { return _src_constants__WEBPACK_IMPORTED_MODULE_0__["f"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "modalDOMElementID", function() { return _src_constants__WEBPACK_IMPORTED_MODULE_0__["g"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "storeKey", function() { return _src_constants__WEBPACK_IMPORTED_MODULE_0__["h"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UX_MODE", function() { return _src_constants__WEBPACK_IMPORTED_MODULE_0__["e"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "OPENLOGIN_METHOD", function() { return _src_constants__WEBPACK_IMPORTED_MODULE_0__["c"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ALLOWED_INTERACTIONS", function() { return _src_constants__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "OPENLOGIN_NETWORK", function() { return _src_constants__WEBPACK_IMPORTED_MODULE_0__["d"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LOGIN_PROVIDER", function() { return _src_constants__WEBPACK_IMPORTED_MODULE_0__["b"]; });

/* harmony import */ var _src_IStore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18);
/* harmony import */ var _src_IStore__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_src_IStore__WEBPACK_IMPORTED_MODULE_1__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _src_IStore__WEBPACK_IMPORTED_MODULE_1__) if(["default","OpenLoginStore","Provider","iframeDOMElementID","modalDOMElementID","storeKey","UX_MODE","OPENLOGIN_METHOD","ALLOWED_INTERACTIONS","OPENLOGIN_NETWORK","LOGIN_PROVIDER"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _src_IStore__WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _src_OpenLogin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _src_OpenLogin__WEBPACK_IMPORTED_MODULE_2__["a"]; });

/* harmony import */ var _src_OpenLoginStore__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "OpenLoginStore", function() { return _src_OpenLoginStore__WEBPACK_IMPORTED_MODULE_3__["a"]; });

/* harmony import */ var _src_Provider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return _src_Provider__WEBPACK_IMPORTED_MODULE_4__["a"]; });

/* harmony import */ var _src_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "documentReady", function() { return _src_utils__WEBPACK_IMPORTED_MODULE_5__["c"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "htmlToElement", function() { return _src_utils__WEBPACK_IMPORTED_MODULE_5__["f"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "whitelistUrl", function() { return _src_utils__WEBPACK_IMPORTED_MODULE_5__["k"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getHashQueryParams", function() { return _src_utils__WEBPACK_IMPORTED_MODULE_5__["d"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "awaitReq", function() { return _src_utils__WEBPACK_IMPORTED_MODULE_5__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "constructURL", function() { return _src_utils__WEBPACK_IMPORTED_MODULE_5__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "storageAvailable", function() { return _src_utils__WEBPACK_IMPORTED_MODULE_5__["j"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "sessionStorageAvailable", function() { return _src_utils__WEBPACK_IMPORTED_MODULE_5__["i"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "localStorageAvailable", function() { return _src_utils__WEBPACK_IMPORTED_MODULE_5__["g"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "preloadIframe", function() { return _src_utils__WEBPACK_IMPORTED_MODULE_5__["h"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getPopupFeatures", function() { return _src_utils__WEBPACK_IMPORTED_MODULE_5__["e"]; });









/***/ })
/******/ ]);